
















































































import { Component, Vue } from 'vue-property-decorator'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

@Component
export default class Contact extends Vue {
  mounted () {
    let fbPlugin = document.createElement('script')
    fbPlugin.setAttribute('src', 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v4.0')
    fbPlugin.setAttribute('sync', 'true')
    fbPlugin.setAttribute('defer', 'true')
    fbPlugin.setAttribute('crossorigin', 'anonymous')
    document.head.appendChild(fbPlugin)
  }
}
